export const VIDEO_UPLOAD_ACCEPT_MIMETYPES: string[] = [
    'video/*',
    'application/mxf',
    'video/3gpp', // 3GP
    'video/x-flv', // FLV
    'video/mp4', // MP4
    'video/webm', // WebM
    'video/x-ms-wmv', // WMV
    'video/x-ms-asf', // ASX
    'video/ogg', // OGM, OGV
    'video/mpeg', // MPEG
    'video/quicktime', // MOV
    'video/x-m4v', // M4V
    'video/avi', // AVI
    'video/x-msvideo', // AVI
    'video/mp2t', // MPEG-TS
];

/**
 * Явные расширения файлов для случаев, когда MIME-тип не распознаётся системой
 */
export const VIDEO_UPLOAD_ACCEPT_EXTENSIONS: string[] = [
    '.ts', // MPEG-TS файлы
];

export const UPLOAD_INPUT_ACCEPT_ATTRIBUTE = [
    ...VIDEO_UPLOAD_ACCEPT_MIMETYPES,
    ...VIDEO_UPLOAD_ACCEPT_EXTENSIONS,
].join(', ');
